// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.search_button_customer {
  padding: 5px 30px;
  background: #1f77b4;
  border: 1px solid #1f77b4;
  border-radius: 5px;
  color: white;
}

.search_button_customer:hover {
  background: transparent;
  color: #1f77b4;
}
.title_of_search {
  background: rgb(214, 229, 249);
  border: 1px solid #1f76b428;
  padding: 10px 30px;
  color: black;
  font-size: 18px;
  cursor: pointer;
  transition: all;
  border-radius: 5px;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.filter_Section_accordion {
  border-radius: 5px;
  border: 1px solid #1f76b428;
}

.filter_option_wrapper {
  padding: 10px;
  background: rgba(255, 255, 255, 0.46);
  transition: all 0.2s ease-in;
}

.downarrow {
  width: 20px;
  height: 20px;
  transition: transform 0.3s ease-out;
}
.downarrow.rotate {
  transform: rotate(-180deg);
}
`, "",{"version":3,"sources":["webpack://./src/Customer/FilterSectionForCustomer/index.css"],"names":[],"mappings":"AAAA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,uBAAuB;EACvB,cAAc;AAChB;AACA;EACE,8BAA8B;EAC9B,2BAA2B;EAC3B,kBAAkB;EAClB,YAAY;EACZ,eAAe;EACf,eAAe;EACf,eAAe;EACf,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,8BAA8B;AAChC;;AAEA;EACE,kBAAkB;EAClB,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,4BAA4B;AAC9B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mCAAmC;AACrC;AACA;EACE,0BAA0B;AAC5B","sourcesContent":[".search_button_customer {\r\n  padding: 5px 30px;\r\n  background: #1f77b4;\r\n  border: 1px solid #1f77b4;\r\n  border-radius: 5px;\r\n  color: white;\r\n}\r\n\r\n.search_button_customer:hover {\r\n  background: transparent;\r\n  color: #1f77b4;\r\n}\r\n.title_of_search {\r\n  background: rgb(214, 229, 249);\r\n  border: 1px solid #1f76b428;\r\n  padding: 10px 30px;\r\n  color: black;\r\n  font-size: 18px;\r\n  cursor: pointer;\r\n  transition: all;\r\n  border-radius: 5px;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: space-between;\r\n}\r\n\r\n.filter_Section_accordion {\r\n  border-radius: 5px;\r\n  border: 1px solid #1f76b428;\r\n}\r\n\r\n.filter_option_wrapper {\r\n  padding: 10px;\r\n  background: rgba(255, 255, 255, 0.46);\r\n  transition: all 0.2s ease-in;\r\n}\r\n\r\n.downarrow {\r\n  width: 20px;\r\n  height: 20px;\r\n  transition: transform 0.3s ease-out;\r\n}\r\n.downarrow.rotate {\r\n  transform: rotate(-180deg);\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
